// extracted by mini-css-extract-plugin
module.exports = {"step__container":"style_step__container__25Q9N","step_svg":"style_step_svg__3QaDV","step_number":"style_step_number__1-ZTO","step_description":"style_step_description__1-Ub3"};